import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/apps/docs/app/ui/layout/sidebar/Sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/apps/docs/app/ui/layout/wrapper/wrapper.css");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/opt/build/repo/apps/docs/context/sidebar/SidebarProvider.tsx");
